(ns rothko.theme.manatee.form2.select.multi-select
  (:refer-clojure :exclude [rem + - * /])
  (:require [garden.arithmetic :refer [+ - * /]]
            [garden.units :refer [rem percent]]
            [garden.color :refer [lighten]]
            [rothko.theme.manatee.colours :refer [colours]]
            [rothko.theme.manatee.form.input :as input-theme]))

(def width (rem 30))
(def container-padding (rem 0.5))

(def select
  {:primary
   {:input-width width
    :option-padding-left (rem 1)
    :options-box-shadow "rgba(0,0,0,0.1) 0px 0px 10px 3px"
    :options-position :absolute
    :options-background-color :white
    :options-padding (rem 1)
    :options-width width
    :selected-background-color (lighten (:blue-light colours) 30)
    :select-padding-bottom (rem 1)
    :width width}

   :pills-inside-input
   {:container-display :flex
    :container-flex-direction :column
    :container-border [[input-theme/border-width :solid (:blue-light colours) ]]
    :container-padding container-padding
    :container-width :fit-content
    :input-border :none
    :input-min-width (- width (* 2 container-padding))
    :input-padding (rem 0.5)
    :pill-background-colour (lighten (:blue-light colours) 30)
    :pill-margin (rem 0.5)
    :pill-padding [[0 (rem 0.5)]]
    :pill-close-icon-padding [[0 (rem 0.5)]]}

   :open-above
   {:options-bottom input-theme/total-height
    :position :relative}

   :open-below
   {:position :initial}})
